module.exports = __webpack_public_path__ + "static/media/fill_59@3x.8aeed883.png";